import React, { lazy, Suspense } from "react";
import PageLoader from "../Components/PageLoader";

const Home = lazy(() => import("../Components/Pages/Home"));
const About = lazy(() => import("../Components/Pages/About"));
const AboutPlatform = lazy(() => import("../Components/Pages/AboutPlatform"));
const Contactus = lazy(() => import("../Components/Pages/Contactus"));
const SocialResponsibility = lazy(() =>
  import("../Components/Pages/SocialResponsibility")
);
const Portfolio = lazy(() => import("../Components/Pages/Porifolio"));
const Admin = lazy(() => import("../Components/Pages/Admin"));
const Login = lazy(() => import("../Components/Pages/Admin/login"));
const AboutTeam = lazy(() => import("../Components/Pages/AboutTeam"));
const AboutAdvisor = lazy(() => import("../Components/Pages/AboutAvisor"));
const Error404 = lazy(() => import("../Components/Pages/Error404"));
export const PageRoutes = [
  {
    path: "/",
    title: "/home",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/about",
    title: "/about",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <About />
      </Suspense>
    ),
  },
  {
    path: "/about-platform",
    title: "/about-platform",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <AboutPlatform />
      </Suspense>
    ),
  },
  {
    path: "/portfolio",
    title: "/portfolio",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Portfolio />
      </Suspense>
    ),
  },
  {
    path: "/social-responsibility",
    title: "/social-responsibility",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <SocialResponsibility />
      </Suspense>
    ),
  },
  {
    path: "/contact-us",
    title: "/contact-us",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Contactus />
      </Suspense>
    ),
  },
  {
    path: "/admin",
    title: "/admin",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Admin />
      </Suspense>
    ),
  },
  {
    path: "/login",
    title: "/login",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/aboutTeam/:id",
    title: "/aboutTeam/:id",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <AboutTeam />
      </Suspense>
    ),
  },
  {
    path: "/aboutadvisor/:id",
    title: "/aboutadvisor/:id",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <AboutAdvisor />
      </Suspense>
    ),
  },
  {
    path: "*",
    title: "Error 404 Not Found",
    component: () => (
      <Suspense fallback={<PageLoader/>}>
        <Error404 />
      </Suspense>
    ),
  },
];
